import { render } from "./TriggerMessageContentWrap.vue?vue&type=template&id=80ab3ed0&scoped=true&ts=true"
import script from "./TriggerMessageContentWrap.vue?vue&type=script&lang=ts"
export * from "./TriggerMessageContentWrap.vue?vue&type=script&lang=ts"

import "./TriggerMessageContentWrap.vue?vue&type=style&index=0&id=80ab3ed0&lang=scss&scoped=true"

import exportComponent from "/builds/root/dev.front.widget/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80ab3ed0"]])

export default __exports__